import { IDeleteFilesCmd } from '@/twapp/server/FileEndpoint';
import { TromanDialog, TromanDialogBody, TromanDialogFooter, TromanDialogTitleHeader } from '../../TromanDialog';
import { ButtonVariants, TromanButton } from '../../Buttons';
import { getAllEntries, IEntrySelection, IFileRoot } from '../model/fileModel';
import { formatStatsMessage, formatStatsSelection, getSelectionStats, ISelectionStats } from '../model/fileStats';

export interface IPreparedDelete {
    selection: IEntrySelection;
    stats: ISelectionStats;
}

export function prepareDelete(selection: IEntrySelection): IPreparedDelete {
    return {
        selection: selection,
        stats: getSelectionStats(selection),
    }
}

export interface IFileDeleteDialogProps {
    root: IFileRoot,
    busy: boolean;
    files?: IPreparedDelete;
    onClose: (cmd?: IDeleteFilesCmd) => void;
}

function createDeleteCmd(root: IFileRoot, files: IPreparedDelete): IDeleteFilesCmd {
    return {
        FileIds: getAllEntries(files.selection).map(x => x.id),
        OwnerId: root.ownerId,
        OwnerType: root.ownerType,
    }
}

export const FileDeleteDialog = ({files, busy, root, onClose}: IFileDeleteDialogProps) => {

    return (
        <TromanDialog open={!!files}>
            <TromanDialogTitleHeader title='Ta bort dokument'/>
            <TromanDialogBody>
                {
                    files && (
                        <>
                            <div>{formatStatsSelection(files.stats.immediate)}.</div>
                            <div>Totalt {formatStatsMessage(files.stats.total)} kommer att raderas.</div>
                        </>
                    )
                }
            </TromanDialogBody>
            <TromanDialogFooter>
            <TromanButton text='Radera' variant={ButtonVariants.Danger} disabled={busy || !(files && files.stats.total.entries > 0)} onClick={() => files && onClose(createDeleteCmd(root, files))}/>
                <TromanButton text='Avbryt' variant={ButtonVariants.Default} disabled={busy} onClick={() => onClose()}/>
            </TromanDialogFooter>
        </TromanDialog>
    )
};
